import React, { ReactNode } from "react";

interface Props extends React.HTMLAttributes<HTMLElement> {
  href?: string;
  children: ReactNode;
  className?: string;
}

export const NewTabLink: React.FC<Props> = (props) => (
  // Don't add rel="noreferrer": AtCoder uses the referrer for analytics.
  // eslint-disable-next-line react/jsx-no-target-blank
  <a
    href={props.href}
    rel="noopener"
    target="_blank"
    className={props.className}
  >
    {props.children}
  </a>
);
